import { render } from "./customer-edit.vue?vue&type=template&id=5a3295d4&scoped=true"
import script from "./customer-edit.vue?vue&type=script&lang=js"
export * from "./customer-edit.vue?vue&type=script&lang=js"

import "./customer-edit.vue?vue&type=style&index=0&id=5a3295d4&scoped=true&lang=less"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3295d4"]])

export default __exports__